import http from './http';
import DefaultDate from '../filters/DefaultDate';

export default {
    getAll() {
        return http.get('/preparation');
    },
    getSingle(id, date, raw = false) {
        const formattedDate = raw ? date : DefaultDate(date);

        return http.get(`/preparation/${id}?datetime=${formattedDate}`);
    },
    getSingleVersions(id) {
        return http.get(`/preparation/${id}/versions`);
    },
    create(substance) {
        return http.post('/preparation', substance);
    },
    update(substance) {
        return http.put(`/preparation/${substance.info.id}`, substance);
    },
    newVersion(substance) {
        return http.put(`/preparation/${substance.info.id}/newversion`, substance);
    },
};
